"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Section_1 = __importDefault(require("../Section"));
var CopyrightWidget_1 = __importDefault(require("./widgets/CopyrightWidget"));
var LinkedinWidget_1 = __importDefault(require("./widgets/LinkedinWidget"));
var BuiltByWidget_1 = __importDefault(require("./widgets/BuiltByWidget"));
var FacebookWidget_1 = __importDefault(require("./widgets/FacebookWidget"));
var OgpWidget_1 = __importDefault(require("./widgets/OgpWidget"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return core_1.createStyles({
        footer: (_a = {
                display: 'flex',
                justifyContent: 'space-between'
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'block',
            },
            _a),
        iconGroup: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
        },
        icons: (_b = {
                marginLeft: theme.spacing(3),
                marginRight: '0px'
            },
            _b[theme.breakpoints.down('sm')] = {
                marginLeft: '0px',
                marginRight: theme.spacing(3),
            },
            _b),
        displayGroup: (_c = {
                display: 'inline-grid'
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'block',
            },
            _c),
        buildByLink: {
            display: 'inline-flex',
            flexGrow: 1,
            align: 'right',
        },
        copyRightGroup: (_d = {
                display: 'inline-grid',
                textAlign: 'right'
            },
            _d[theme.breakpoints.down('sm')] = {
                display: 'block',
                textAlign: 'left',
            },
            _d),
    });
});
var BaseLayoutLowFooter = function () {
    var classes = useStyles();
    return (react_1.default.createElement(Section_1.default, { backgroundType: "black", verticalMultiplier: 0.5 },
        react_1.default.createElement("div", { style: { display: 'inline' } },
            react_1.default.createElement("footer", { className: classes.footer },
                react_1.default.createElement("div", { className: classes.buildByLink },
                    react_1.default.createElement(BuiltByWidget_1.default, null)),
                react_1.default.createElement("div", { className: classes.displayGroup },
                    react_1.default.createElement("div", { className: classes.iconGroup },
                        react_1.default.createElement(LinkedinWidget_1.default, { className: classes.icons }),
                        react_1.default.createElement(FacebookWidget_1.default, { className: classes.icons }),
                        react_1.default.createElement(OgpWidget_1.default, { className: classes.icons })),
                    react_1.default.createElement("div", { className: classes.copyRightGroup },
                        react_1.default.createElement(CopyrightWidget_1.default, null)))))));
};
exports.default = BaseLayoutLowFooter;
